import { render } from "./EtatsProduitsEntree.vue?vue&type=template&id=2daeb4aa&ts=true"
import script from "./EtatsProduitsEntree.vue?vue&type=script&lang=ts"
export * from "./EtatsProduitsEntree.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__